import { WithDroneComponentTrackingForForwarded, WithDroneComponentTrackingForNormal } from './hoc/WithDroneComponentTracking.js';
import { isQueryParamExist } from './isQueryParamExist.js';
import { DRONE_EXTENSION_ENABLED } from '../static/constants.js';

var trackForwardedComponent = function trackForwardedComponent(Component) {
  var trackingOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isQueryParamExist(DRONE_EXTENSION_ENABLED)) {
    var _trackingOptions$addW = trackingOptions.addWrapper,
      addWrapper = _trackingOptions$addW === void 0 ? false : _trackingOptions$addW,
      _trackingOptions$isSu = trackingOptions.isSubComponent,
      isSubComponent = _trackingOptions$isSu === void 0 ? false : _trackingOptions$isSu;
    var tracked = WithDroneComponentTrackingForForwarded(Component, addWrapper, isSubComponent);
    return tracked;
  }
  return Component;
};
var trackNormalComponent = function trackNormalComponent(Component) {
  var trackingOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isQueryParamExist(DRONE_EXTENSION_ENABLED)) {
    var _trackingOptions$addW2 = trackingOptions.addWrapper,
      addWrapper = _trackingOptions$addW2 === void 0 ? false : _trackingOptions$addW2,
      _trackingOptions$isSu2 = trackingOptions.isSubComponent,
      isSubComponent = _trackingOptions$isSu2 === void 0 ? false : _trackingOptions$isSu2;
    var tracked = WithDroneComponentTrackingForNormal(Component, addWrapper, isSubComponent);
    return tracked;
  }
  return Component;
};

export { trackForwardedComponent, trackNormalComponent };
//# sourceMappingURL=trackComponent.js.map
